import React from 'react';
import { Grid } from '@material-ui/core';
import AddRolesDialog from '../featureaccesscontrol/AddRolesDialog';

const AccessRolesStep = props => {
  const {
    contactCreated,
    creation,
    onSubmitEnd,
    setAccessRoles,
    accessRoles,
    setSelectedAccessRoles
  } = props;
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <AddRolesDialog
          userId={contactCreated.userId}
          creation={creation}
          onSubmitEnd={onSubmitEnd}
          setAccessRoles={setAccessRoles}
          accessRoles={accessRoles}
          setSelectedAccessRoles={setSelectedAccessRoles}
        />
      </Grid>
    </Grid>
  );
};

export default AccessRolesStep;
